import axios from 'axios';
import authHeader from '../auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/radar' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/radar';

class PlayerRadarService {

  getRadarData(playerId, teamIds, seasonIds, positionsPlayed, positionId, minMax,minMaxSeason, clientId, radarId, 
    allPositions, isRadar,allGames, url, zone, browser, metaInfo = null, isAvgLeague = false) {
    let options = {
      params:{
       isAvgLeague, url, zone, browser, metaInfo
      }
    }
    return axios.get(API_URL  + "/player/" + playerId + "/seasons/" + seasonIds + "/teams/" + teamIds + "/positions-played/"
    + positionsPlayed + "/position/" + positionId + "/min-max/" + minMax + "/min-max-season/" + minMaxSeason +
      "/client/" + clientId + "/radar/" + radarId + "/all-positions/" + allPositions + "/is-radar/" + isRadar + "/all-games/" + allGames, options);
  }

  getRadarDataByGames(playerId, seasonId, positionId, minMax, minMaxSeason, clientId, radarId, isRadar, url, zone, browser, 
    metaInfo = null, games = 6, from = null, to = null, isAvgLeague = false) {
    let options = {
      params:{
        isAvgLeague, url, zone, browser, metaInfo, games, from, to
      }
    }
    return axios.get(API_URL  + "/player/" + playerId + "/season/" + seasonId +
      "/position/" + positionId + "/min-max/" + minMax + "/min-max-season/" + minMaxSeason +
      "/client/" + clientId + "/radar/" + radarId + "/is-radar/" + isRadar, options);
  }

  /* Get Player info in that seasons as Yellow cards, Red cards, Goals and Assists order by regular leagues first for Radar Description */
  getRadarDescriptionBasicStats(seasonIds, playerId, shortPosition) {
    return axios.get(API_URL  + "/player-season-info/player/" + playerId + "/seasons/" + seasonIds + "/position/" + shortPosition);
  }

  getRadarTemplatesByPositionsAndClientId(positionIds) {
    return axios.get(API_URL  + "/templates/positions/" + positionIds);
  }
}

export default new PlayerRadarService();



// WEBPACK FOOTER //
// ./src/services/player/playerRadar.service.js